import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const staffToken = sessionStorage.getItem('token');
  const participantToken = sessionStorage.getItem('participant_auth_token');

  // Only attach STAFF token for staff APIs.
  // Participant registration/login/program APIs (e.g. /api/auth/*, /api/program/*) must not receive the staff token.
  const isStaffApi = req.url.includes('/api/staff');
  const isFileApi = req.url.includes('/api/file');
  const isParticipantProtectedApi =
    req.url.includes('/api/program') ||
    req.url.includes('/api/job') ||
    req.url.includes('/api/auth/profile');

  if (staffToken && isStaffApi) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${staffToken}`,
      },
    });
  } else if (participantToken && (isFileApi || isParticipantProtectedApi)) {
    // Prefer participant token for /api/file — same path used by program uploads.
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${participantToken}`,
      },
    });
  } else if (staffToken && isFileApi) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${staffToken}`,
      },
    });
  }

  return next(req);
};

